import * as React from 'react';
// @ts-expect-error
import ReactTooltip from 'react-tooltip';

import {colors} from 'shells/colors/colors';
import {Body} from 'shells/typography/body';

import type {ExternalMeetingFragment} from 'nutshell-graphql-types';

import styles from './duration-with-recording.module.css';

type Props = {
    meeting: ExternalMeetingFragment;
};

export function DurationWithRecording(props: Props) {
    const {meeting} = props;
    const duration = meeting.activity ? meeting.activity.duration : meeting.duration;

    React.useEffect(() => {
        ReactTooltip.rebuild();
    });

    // Get recording status
    const recordingStatus = meeting.recordingStatus;
    let tooltipText = '';
    let iconColor: string = colors.placeholder;
    let isAnimating = false;

    if (
        // @ts-expect-error
        (recordingStatus === 'PROCESSED' || recordingStatus === 'COMPLETE') &&
        meeting.recordingUrl
    ) {
        tooltipText = 'Recorded';
        iconColor = colors.red;
    } else if (recordingStatus === 'PROCESSING') {
        tooltipText = 'Recording processing…';
        iconColor = colors.placeholder;
        isAnimating = true;
    } else if (recordingStatus === 'NONE') {
        tooltipText = 'Not recorded';
        iconColor = colors.placeholder;
    }

    // Duration display
    const durationValue = duration ? duration.formatted : null;
    const inProgress = duration === null;

    return (
        <div className='flex gap-4 align-center'>
            {tooltipText && (
                <div
                    data-tip={tooltipText}
                    style={{
                        width: 8,
                        height: 8,
                        borderRadius: '50%',
                        backgroundColor: iconColor,
                        flexShrink: 0,
                    }}
                    className={isAnimating ? styles['recording-icon-animating'] : ''}
                />
            )}
            <Body size='small' isItalic={inProgress} color={inProgress ? 'light' : undefined}>
                {durationValue || 'In progress'}
            </Body>
        </div>
    );
}
